
//
// Ported to React from http://jquery-elastic.googlecode.com/svn/trunk/jquery.elastic.source.js
//

'use strict';

var React = require('react'),
    update = require('react/lib/update'),
    shallowEqual = require('react/lib/shallowEqual'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var MIMICS = [
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'fontSize',
  'lineHeight',
  'fontFamily',
  'width',
  'fontWeight',
  'borderTopWidth',
  'borderRightWidth',
  'borderBottomWidth',
  'borderLeftWsidth',
  'borderTopStyle',
  'borderTopColor',
  'borderRightStyle',
  'borderRightColor',
  'borderBottomStyle',
  'borderBottomColor',
  'borderLeftStyle',
  'borderLeftColor'
];

var Textarea = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {

    // Controls whether TextArea is collapsed to the exact height of its content on blur.

    // You might want to set it to `false` when there is just a single field and a button,
    // so that the button doesn't jump out of the cursor when it is clicked.

    collapseOnBlur: React.PropTypes.bool.isRequired
  },

  getDefaultProps: function () {
    return {
      collapseOnBlur: true,
      extraLineCount: 1
    };
  },

  getInitialState: function () {
    return {
      style: {}
    };
  },

  setStyle: function (style) {
    var newStyle = update(this.state.style, {
      $merge: style
    });

    if (shallowEqual(newStyle, this.state.style)) {
      return;
    }

    this.setState({
      style: newStyle
    });
  },

  componentDidUpdate: function (prevProps, prevState) {
    if (prevProps.value !== this.props.value ||
        this.state.twin !== prevState.twin) {

      this.setStyleAccordingToTwin();
    }
  },

  componentDidMount: function () {
    window.setTimeout(this.createTwin, 0);
    window.addEventListener('resize', this.handleWindowResize, false);
  },

  componentWillUnmount: function () {
    window.removeEventListener('resize', this.handleWindowResize, false);
    this.destroyTwin();
  },

  render: function () {
    // Undefined value causes Textarea to retain previous value
    var value = this.props.value || '';

    return (
      <textarea {...this.props}
                style={this.state.style}
                value={value}
                onBlur={this.handleBlur} />
    );
  },

  handleWindowResize: function () {
    if (!this.isMounted() || !this.state.twin) {
      return;
    }

    this.destroyTwin(true);
    this.createTwin();
    this.setStyleAccordingToTwin(true);
  },

  handleBlur: function (e) {
    var size = this.getTwinSize(),
        height = size.height;

    if (this.props.collapseOnBlur && height < this.state.maxHeight) {
      this.setStyle({
        height: Math.max(height, this.state.minHeight)
      });
    }

    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  },

  createTwin: function () {
    if (!this.isMounted()) {
      return;
    }

    var el = this.getDOMNode(),
        style = window.getComputedStyle(el),
        lineHeight = parseInt(style.lineHeight, 10) || parseInt(style.fontSize, 10),
        minHeight = parseInt(style.height, 10) || lineHeight * (1 + this.props.extraLineCount),
        maxHeight = parseInt(style.maxHeight, 10) || Number.MAX_VALUE,
        twin;

    twin = document.createElement('div');
    twin.setAttribute('style', 'position: absolute; display: none; visibility: hidden; word-wrap: break-word; white-space: pre-wrap;');

    if (maxHeight < 0) {
      maxHeight = Number.MAX_VALUE;
    }

    for (var i = 0; i < MIMICS.length; i++) {
      twin.style[MIMICS[i]] = style[MIMICS[i]];
    }

    document.body.appendChild(twin);

    this.setState({
      lineHeight: lineHeight,
      minHeight: minHeight,
      maxHeight: maxHeight,
      twin: twin,
      style: {
        overflow: 'hidden'
      }
    });
  },

  destroyTwin: function (resetState) {
    var twin = this.state.twin;
    if (twin && twin.parentNode === document.body) {
      document.body.removeChild(twin);
    }

    if (resetState) {
      this.setState({
        lineHeight: null,
        minHeight: null,
        maxHeight: null,
        twin: null,
        style: {}
      });
    }
  },

  getTwinSize: function () {
    var size = {},
        twin = this.state.twin;

    twin.style.display = 'block';

    size.width = twin.offsetWidth;
    size.height = twin.offsetHeight;

    twin.style.display = 'none';

    return size;
  },

  setStyleAccordingToTwin: function (forced) {
    var el = this.getDOMNode(),
        twin = this.state.twin,
        lineHeight = this.state.lineHeight,
        minHeight = this.state.minHeight,
        maxHeight = this.state.maxHeight,
        size;

    if (!twin) {
      return;
    }

    // Get curated content from the textarea.
    var textareaContent = el.value.replace(/&/g,'&amp;').replace(/ {2}/g, '&nbsp;').replace(/<|>/g, '&gt;').replace(/\n/g, '<br />');

    // Compare curated content with curated twin.
    var twinContent = twin.innerHTML.replace(/<br>/ig,'<br />');

    if (forced || textareaContent + '&nbsp;' !== twinContent) {
      // Add an extra white space so new rows are added when you are at the end of a row.
      twin.innerHTML = textareaContent + '&nbsp;';

      size = this.getTwinSize();

      var extraLineHeight = lineHeight * this.props.extraLineCount;

      // Change textarea height if twin plus the height of one line differs more than 3 pixel from textarea height
      if (Math.abs(size.height + extraLineHeight - el.offsetHeight) > 3) {
        var goalHeight = size.height + extraLineHeight;
        if (goalHeight >= maxHeight) {
          this.setHeightAndOverflow(maxHeight, 'auto');
        } else if (goalHeight <= minHeight) {
          this.setHeightAndOverflow(minHeight, 'hidden');
        } else {
          this.setHeightAndOverflow(goalHeight, 'hidden');
        }
      }
    }
  },

  setHeightAndOverflow: function (height, overflow) {
    var el = this.getDOMNode(),
        curatedHeight = Math.floor(parseInt(height, 10));

    if (el.offsetHeight !== curatedHeight) {
      this.setStyle({
        height: curatedHeight,
        overflow: overflow
      });
    }
  }
});

module.exports = Textarea;


/** WEBPACK FOOTER **
 ** ./atoms/Textarea.jsx
 **/